<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-lg hidden-xl navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">{{form.cod ? 'Editar' : 'Cadastrar'}} agenda</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content content-area pt-60 bottom-sp60">
              
            <div class="container hidden-xs hidden-md">
                <h2>{{form.cod ? 'Editar' : 'Cadastrar'}} agenda</h2>
            </div>

            <div class="">
                <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">                        
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Tipo</div>
                                    <div class="item-input-wrap">
                                        <select class="form-control" v-model="form.tipo">
                                            <option value="" disabled selected hidden>Selecione..</option>
                                            <option value="online">Atendimento online</option>
                                            <option value="presencial">Atendimento presencial (consultório)</option>
                                            <option value="domiciliar">Atendimento domiciliar</option>
                                        </select>
                                    </div>
                                </div>
                            </li>                                         
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome da agenda</div>
                                    <div class="item-input-wrap">
                                        <input type="text" placeholder="Escreva o nome de identificação.." v-model="form.nome" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                        </ul>


                        <p style="padding-left: 12px" v-if="form.tipo == 'presencial'">
                            <i class="las la-hospital-alt"></i> 
                            Dados do local de atendimento
                        </p>

                        <ul class="row" v-if="form.tipo == 'presencial'">
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.localNome" placeholder="Escreva o nome da clínica.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>                            
                            <li class="item-content item-input col-60">
                                <div class="item-inner">
                                    <div class="item-title item-label">CEP <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="form.localCep" placeholder="_____-___" />
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Rua <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.localEndereco" placeholder="Escreva o endereço.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Número (opcional)</div>
                                    <div class="item-input-wrap">
                                        <input type="tel" v-model="form.localNumero" placeholder="__" value="" class="form-control" />
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Complemento <small>(opcional)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.localComplemento" placeholder="" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>     
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Bairro <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.localBairro" placeholder="Escreva o bairro.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>            
                            <li class="item-content item-input col-100" >
                                <div class="item-inner">
                                    <div class="item-title item-label">Cidade <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.localCidade" placeholder="Escreva a sua cidade.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>     
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Estado <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <select id="estado" class="form-control" readonly="" name="estado" required="" v-model="form.localEstado" >
                                            <option value="" disabled selected hidden>Estado</option>
                                            <option value="AC">Acre</option>
                                            <option value="AL">Alagoas</option>
                                            <option value="AP">Amapá</option>
                                            <option value="AM">Amazonas</option>
                                            <option value="BA">Bahia</option>
                                            <option value="CE">Ceará</option>
                                            <option value="DF">Distrito Federal</option>
                                            <option value="ES">Espírito Santo</option>
                                            <option value="GO">Goiás</option>
                                            <option value="MA">Maranhão</option>
                                            <option value="MT">Mato Grosso</option>
                                            <option value="MS">Mato Grosso do Sul</option>
                                            <option value="MG">Minas Gerais</option>
                                            <option value="PA">Pará</option>
                                            <option value="PB">Paraíba</option>
                                            <option value="PR">Paraná</option>
                                            <option value="PE">Pernambuco</option>
                                            <option value="PI">Piauí</option>
                                            <option value="RJ">Rio de Janeiro</option>
                                            <option value="RN">Rio Grande do Norte</option>
                                            <option value="RS">Rio Grande do Sul</option>
                                            <option value="RO">Rondônia</option>
                                            <option value="RR">Roraima</option>
                                            <option value="SC">Santa Catarina</option>
                                            <option value="SP">São Paulo</option>
                                            <option value="SE">Sergipe</option>
                                            <option value="TO">Tocantins</option>
                                        </select>                                                  
                                    </div>
                                </div>
                            </li>  
                        </ul>  

                        <div class="row mt-20">

<!--                             <div class="col-50" v-for="item in form.imagens">
                                <div class="gallery-item" :style="{'background-image': 'url(' + (item.indexOf('uploads') != -1 ? ($root.config.url + '/' + item) : item) + ')'}">
                                    <button type="button" class="button apagar color-red button-round button-fill" v-on:click.stop.prevent="delImagem(item)">
                                        <i class="las la-times"></i> Apagar
                                    </button>
                                    <button type="button" class="button button-round button-fill color-green principal" v-if="form.imagem == item" v-on:click="principalImagem(item)">
                                        <i class="las la-check"></i>
                                        Foto principal
                                    </button>
                                    <button type="button" class="button button-fill color-orange button-round small" v-if="form.imagem != item" v-on:click="principalImagem(item)">
                                        <i class="las la-check"></i>
                                        Tornar principal
                                    </button>                                               
                                </div>
                            </div> -->

                        </div>                          
                    </div>

                    <div class="block">
                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>

        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'GerenciarAgenda',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },          
            "form": {
                "cod":              "",
                "nome":             "",
                "tipo":             "",
                "localEstado":      ""
            }            
        }
    },
    watch: {
        "form.tipo": function(val) {
            var self = this;
            console.log("watch form.tipo >>", val);

            if (val == "online" && !self.form.nome) {
                self.form.nome      = "Atendimento online";
                self.$forceUpdate();
            } else if (val == "presencial" && !self.form.nome) {
                self.form.nome      = "Atendimento em consultório";
                self.$forceUpdate();
            } else if (val == "domiciliar" && !self.form.nome) {
                self.form.nome      = "Atendimento domiciliar";
                self.$forceUpdate();
            }
        },
        "form.localCep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        }        
    },    
    methods: {   
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.form.localEndereco  = response.data.logradouro;
                                self.form.localBairro    = response.data.bairro;
                                self.form.localCidade    = response.data.localidade;
                                self.form.localEstado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },                    
        submit: function(e) {
            
            var self            = this;


            loading.show();

            var request = function() {
                self.form._cod      = self.$root.user.cod;
                self.form._token    = self.$root.user.token;
                console.log("submit()", e, self.form, JSON.stringify(self.form));
                e.preventDefault();
                self.loading.submit = true;
                loading.show();
                    
                var a = "post";
                if (self.form.cod) {
                    a = "put";
                }

                axios[a]("api/agendas.php", self.form)
                .then(response => {
                    
                    self.loading.submit = false;
                    console.log("submit() response", response)
                    loading.hide();
                    // alert(response.data.message);
                    self.$root.back();
                    
                })
                .catch(error => {
                    console.log("submit() error", error)
                    loading.hide();
                    self.loading.submit = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            }

            if (self.form.tipo == "presencial") {
                var geocoder                = new google.maps.Geocoder();
                var endereco                = self.form.localEndereco + ", " + self.form.localNumero + " - " + self.form.localBairro + ", " + self.form.localCidade + " - " + self.form.localEstado + ", " + self.form.localCep;
                geocoder.geocode({ 'address': endereco}, function (results, status) {

                    console.log("Localizacao resultado >>", results)

                    if (results[0]) {

                        var latitude        = results[0].geometry.location.lat();
                        var longitude       = results[0].geometry.location.lng();
                        self.form.localLatitude  = latitude;
                        self.form.localLongitude = longitude;
                        console.log("Setou localizacao", self.form);
                        self.$forceUpdate();
                        request();
                    } else {
                        loading.hide();
                        alert("Erro! Informe um endereço válido e tente novamente por favor.")
                    }

                });                  
            } else {
                request();
            }

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/agendas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarAgendas") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },
    activated: function() {
        var self = this;
        // self.get();
    },       
    mounted: function() {
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .button-round {
        border-radius: 20px !important;
    }

    .badge-large {
        padding: 15px;
    }

    .badge-outline:not(.color-green) {
        background: transparent !important;
        border: 2px solid #064972 !important;
        color: #064972;
    }

    .badge.color-secondary {
        border: 2px solid #064972 !important;
    }

    .badge.color-primary {
        border: 2px solid #0f8cd5 !important;
    }    

    .badge.color-green:not(.badge-outline) {
        border: 2px solid #4cd964 !important;
    }

    .badge-outline.color-green {
        background: transparent !important;
        border: 2px solid #4cd964 !important;
        color: #4cd964;
    }    

    .container {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/GerenciarAgendas.vue